// extracted by mini-css-extract-plugin
export default {"label":"_3G_JC","popularOptions":"_3NhSe"};